import React from "react";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
    StyledH2,
    StyledLabel,
    StyledModal,
    StyledTextInput,
    StyledSelectInput,
} from "@aureskonnect/react-ui";
import ReactSwitch from "react-switch";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { AvForm, AvGroup } from "availity-reactstrap-validation";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { httpRegex } from "@constants/index";
import ShowPasswordSvgIcon from "@components/Common/SvgIcons/ShowPasswordSvgIcon";
import HidePasswordSvgIcon from "@components/Common/SvgIcons/HidePasswordSvgIcon";
import { store } from "../store";
import { useSnapshot } from "valtio";
import {
    COMMUNICATION_OPTIONS,
    COMMUNICATION_LOCAL,
} from "./moneticsConstants";
import { FieldError } from "./components/FieldError";

type AdyenConfigurationModalType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    setCodeSupport: Function;
    merchantAccount: any;
    setMerchantAccount: Function;
    cryptoVersion: any;
    setCryptoVersion: Function;
    keyIdentifier: any;
    setKeyIdentifier: Function;
    passphrase: any;
    setPassphrase: Function;
    keyVersion: any;
    setKeyVersion: Function;
    communication: any;
    setCommunication: Function;
    currency: any;
    setAdyenConfig: Function;
    adyenConfig: any;
    webhook: any;
    setWebhook: Function;
    merchantTicket: boolean;
    customerTicket: boolean;
    apiKey: any;
    userName: any;
    userPassword: any;
    setMerchantTicket: Function;
    setCustomerTicket: Function;
    setApiKey: Function;
    setUserName: Function;
    setUserPassword: Function;
    isConsult: boolean;
    devise: any;
    shopIds: any;
    setIsEdited: Function;
    shopIdentifier: string;
    setShopIdentifier: Function;
    editedData: any;
    isAutoFill: boolean;
};
export function AdyenConfigurationModal({
    isModalOpened,
    setIsModalOpened,
    setCodeSupport,
    merchantAccount,
    setMerchantAccount,
    cryptoVersion,
    setCryptoVersion,
    keyIdentifier,
    setKeyIdentifier,
    passphrase,
    setPassphrase,
    keyVersion,
    setKeyVersion,
    communication,
    setCommunication,
    currency,
    setAdyenConfig,
    adyenConfig,
    webhook,
    setWebhook,
    merchantTicket,
    customerTicket,
    apiKey,
    userName,
    userPassword,
    setMerchantTicket,
    setCustomerTicket,
    setApiKey,
    setUserName,
    setUserPassword,
    isConsult,
    devise,
    shopIds,
    setIsEdited,
    setShopIdentifier,
    shopIdentifier,
    editedData,
    isAutoFill,
}: AdyenConfigurationModalType) {
    const { t } = useTranslation();
    const { identifierShop } = useSnapshot(store);
    let communications = COMMUNICATION_OPTIONS;
    const initialAdyenConfig = React.useRef(adyenConfig);

    const [inputMerchantAccount, setInputMerchantAccount] = React.useState<
        boolean
    >(false);
    const [inputShopId, setInputShopId] = React.useState<boolean>(false);
    const [inputCryptoVersion, setInputCryptoVersion] = React.useState<boolean>(
        false
    );
    const [inputKeyIdentifier, setInputKeyIdentifier] = React.useState<boolean>(
        false
    );
    const [inputPassphrase, setInputPassphrase] = React.useState<boolean>(
        false
    );
    const [inputKeyVersion, setInputKeyVersion] = React.useState<boolean>(
        false
    );
    const [inputCommunication, setInputCommunication] = React.useState<boolean>(
        false
    );
    const [inputWebHook, setInputWebhook] = React.useState<boolean>(false);
    const [inputApiKey, setInputApiKey] = React.useState<boolean>(false);
    const [inputUserName, setInputUserName] = React.useState<boolean>(false);
    const [inputUserPassword, setInputUserPassword] = React.useState<boolean>(
        false
    );

    const [isInvalidWebHook, setIsInvalidWebhook] = React.useState<boolean>(
        false
    );
    const [isNewPasswordDisplayed, setIsNewPasswordDisplayed] = React.useState<
        boolean
    >(false);

    const handleValidate = () => {
        if (merchantAccount === "") setInputMerchantAccount(true);
        if (cryptoVersion === "") setInputCryptoVersion(true);
        if (keyIdentifier === "") setInputKeyIdentifier(true);
        if (passphrase === "") setInputPassphrase(true);
        if (keyVersion === "") setInputKeyVersion(true);
        if (communication === "") setInputCommunication(true);
        if (webhook === "") setInputWebhook(true);
        if (apiKey === "") setInputApiKey(true);
        if (userName === "") setInputUserName(true);
        if (userPassword === "") setInputUserPassword(true);
        if (shopIdentifier === "") setInputShopId(true);

        if (
            shopIdentifier !== "" &&
            communication !== "" &&
            merchantAccount !== "" &&
            cryptoVersion !== "" &&
            keyIdentifier !== "" &&
            passphrase !== "" &&
            keyVersion !== "" &&
            webhook !== "" &&
            apiKey !== "" &&
            userName !== "" &&
            userPassword !== "" &&
            ((devise.length !== 0 && shopIds.length <= 1) || shopIds.length > 1)
        ) {
            setAdyenConfig({
                currency: currency,
                communication: communication,
                merchantAccount: merchantAccount,
                cryptoVersion: cryptoVersion,
                keyIdentifier: keyIdentifier,
                passphrase: passphrase,
                keyVersion: keyVersion,
                webhook: webhook,
                merchantTicket: merchantTicket,
                customerTicket: customerTicket,
                apiKey: apiKey,
                userName: userName,
                userPassword: userPassword,
                shopIdentifier: shopIdentifier,
            });
            setIsModalOpened(false);
        }
    };

    const cancelButtonOnClickEvent = () => {
        if (
            adyenConfig.merchantAccount !== "" &&
            adyenConfig &&
            adyenConfig.merchantAccount !== undefined
        ) {
            setMerchantAccount(adyenConfig.merchantAccount);
            setCryptoVersion(adyenConfig.cryptoVersion);
            setKeyIdentifier(adyenConfig.keyIdentifier);
            setPassphrase(adyenConfig.passphrase);
            setKeyVersion(adyenConfig.keyVersion);
            setCommunication(adyenConfig.communication);
            setWebhook(adyenConfig.webhook);
            setApiKey(adyenConfig.apiKey);
            setUserName(adyenConfig.userName);
            setUserPassword(adyenConfig.userPassword);
            setMerchantTicket(adyenConfig.merchantTicket);
            setCustomerTicket(adyenConfig.customerTicket);
            setShopIdentifier(adyenConfig.shopIdentifier);
            setAdyenConfig({
                ...initialAdyenConfig.current,
            });
        } else {
            setMerchantAccount("");
            setCryptoVersion("");
            setKeyIdentifier("");
            setPassphrase("");
            setKeyVersion("");
            setCommunication("");
            setWebhook("");
            setApiKey("");
            setUserName("");
            setUserPassword("");
            setMerchantTicket("");
            setCustomerTicket("");
            setShopIdentifier("");
            setAdyenConfig({
                currency: "",
                communication: COMMUNICATION_LOCAL,
                merchantAccount: "",
                cryptoVersion: "",
                keyIdentifier: "",
                passphrase: "",
                keyVersion: "",
                webhook: "",
                merchantTicket: "",
                customerTicket: true,
                apiKey: "",
                userName: "",
                userPassword: "",
                shopIdentifier: "",
            });
        }
        setIsModalOpened(false);
    };
    React.useEffect(() => {
        if (isAutoFill === true) {
            setShopIdentifier(identifierShop);
            setAdyenConfig({
                ...adyenConfig,
                shopIdentifier: identifierShop,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAutoFill]);
    return (
        <StyledModal
            isOpen={isModalOpened}
            centered
            className="supportCode__clz"
        >
            <ModalHeader
                className="text-capitalize mnt_icn_close"
                toggle={cancelButtonOnClickEvent}
            >
                <StyledH2>{t("Adyen configuration")}</StyledH2>
            </ModalHeader>
            <ModalBody style={{ height: "600px", overflowY: "auto" }}>
                <AvForm>
                    <AvGroup>
                        <StyledLabel
                            htmlFor="text"
                            className="mt-3 required__clz"
                        >
                            {t("Merchant account")}
                        </StyledLabel>
                        <StyledTextInput
                            data-testid="monetics-adyen-config-merchant-account-input"
                            disabled={isAutoFill}
                            id="merchantAccount-input"
                            name="merchantAccount-input"
                            placeholder={t("Write")}
                            value={merchantAccount}
                            onChange={(e: any) => {
                                setMerchantAccount(e.target.value.trim());
                                setAdyenConfig({
                                    ...adyenConfig,
                                    merchantAccount: e.target.value.trim(),
                                });
                                setInputMerchantAccount(false);
                                setIsEdited(true);
                            }}
                            className={classnames("mnt_inp_merchantAccount", {
                                input__clz: inputMerchantAccount,
                                readOnly__clz: isConsult,
                            })}
                        />
                        {inputMerchantAccount ? (
                            <FieldError style={{ color: "red" }}>
                                {t("Please enter a merchant account")}
                            </FieldError>
                        ) : null}
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel
                            htmlFor="text"
                            className="mt-3 required__clz"
                        >
                            {t("Shop identifier")}
                        </StyledLabel>
                        <StyledTextInput
                            data-testid="monetics-adyen-config-shop-identifier-input"
                            disabled={isAutoFill}
                            id="shopIdentifier-input"
                            name="shopIdentifier-input"
                            placeholder={t("Write")}
                            value={shopIdentifier}
                            onChange={(e: any) => {
                                setShopIdentifier(e.target.value);
                                setAdyenConfig({
                                    ...adyenConfig,
                                    shopIdentifier: e.target.value,
                                });
                                setInputShopId(false);
                                setIsEdited(true);
                            }}
                            className={classnames("", {
                                readOnly__clz: isConsult,
                                input__clz: inputShopId,
                            })}
                        />
                        {inputShopId ? (
                            <FieldError style={{ color: "red" }}>
                                {t("Please enter a shop identifier")}
                            </FieldError>
                        ) : null}
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel
                            htmlFor="text"
                            className="mt-3 required__clz"
                        >
                            {t("Adyen CryptoVersion")}
                        </StyledLabel>
                        <StyledTextInput
                            data-testid="monetics-adyen-config-crypto-version-input"
                            disabled={isAutoFill}
                            id="cryptoVersion-input"
                            name="cryptoVersion-input"
                            placeholder={t("Write")}
                            value={cryptoVersion}
                            onChange={(e: any) => {
                                setCryptoVersion(e.target.value.trim());
                                setAdyenConfig({
                                    ...adyenConfig,
                                    cryptoVersion: e.target.value.trim(),
                                });
                                setInputCryptoVersion(false);
                                setIsEdited(true);
                            }}
                            className={classnames(
                                "mnt_inp_adyenCryptoVersion",
                                {
                                    input__clz: inputCryptoVersion,
                                    readOnly__clz: isConsult,
                                }
                            )}
                        />
                        {inputCryptoVersion ? (
                            <FieldError style={{ color: "red" }}>
                                {t("Please enter Adyen cryptoVersion")}
                            </FieldError>
                        ) : null}
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel
                            htmlFor="text"
                            className="mt-3 required__clz"
                        >
                            {t("Key Identifier")}
                        </StyledLabel>
                        <StyledTextInput
                            data-testid="monetics-adyen-config-key-identifier-input"
                            disabled={isAutoFill}
                            id="keyIdentifier-input"
                            name="keyIdentifier-input"
                            placeholder={t("Write")}
                            value={keyIdentifier}
                            onChange={(e: any) => {
                                setKeyIdentifier(e.target.value.trim());
                                setAdyenConfig({
                                    ...adyenConfig,
                                    keyIdentifier: e.target.value.trim(),
                                });
                                setInputKeyIdentifier(false);
                                setIsEdited(true);
                            }}
                            className={classnames("mnt_inp_keyIdentifier", {
                                input__clz: inputKeyIdentifier,
                                readOnly__clz: isConsult,
                            })}
                        />
                        {inputKeyIdentifier ? (
                            <FieldError style={{ color: "red" }}>
                                {t("Please enter key identifier")}
                            </FieldError>
                        ) : null}
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel
                            htmlFor="text"
                            className="mt-3 required__clz"
                        >
                            {t("Passphrase")}
                        </StyledLabel>
                        <StyledTextInput
                            data-testid="monetics-adyen-config-passphrase-input"
                            disabled={isAutoFill}
                            id="passphrase-input"
                            name="passphrase-input"
                            placeholder={t("Write")}
                            value={passphrase}
                            onChange={(e: any) => {
                                setPassphrase(e.target.value.trim());
                                setAdyenConfig({
                                    ...adyenConfig,
                                    passphrase: e.target.value.trim(),
                                });
                                setInputPassphrase(false);
                                setIsEdited(true);
                            }}
                            className={classnames("mnt_inp_passphrase", {
                                input__clz: inputPassphrase,
                                readOnly__clz: isConsult,
                            })}
                        />
                        {inputPassphrase ? (
                            <FieldError style={{ color: "red" }}>
                                {t("Please enter a passphrase")}
                            </FieldError>
                        ) : null}
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel
                            htmlFor="text"
                            className="mt-3 required__clz"
                        >
                            {t("KeyVersion")}
                        </StyledLabel>
                        <StyledTextInput
                            data-testid="monetics-adyen-config-key-version-input"
                            disabled={isAutoFill}
                            id="keyVersion-input"
                            name="keyVersion-input"
                            placeholder={t("Write")}
                            value={keyVersion}
                            onChange={(e: any) => {
                                setKeyVersion(e.target.value.trim());
                                setAdyenConfig({
                                    ...adyenConfig,
                                    keyVersion: e.target.value.trim(),
                                });
                                setInputKeyVersion(false);
                                setIsEdited(true);
                            }}
                            className={classnames("mnt_inp_keyVersion", {
                                input__clz: inputKeyVersion,
                                readOnly__clz: isConsult,
                            })}
                        />
                        {inputKeyVersion ? (
                            <FieldError style={{ color: "red" }}>
                                {t("Please enter a keyVersion")}
                            </FieldError>
                        ) : null}
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel
                            htmlFor="example-input"
                            className="required__clz mt-3"
                        >
                            {t("Currency")}
                        </StyledLabel>
                        <StyledTextInput
                            data-testid="monetics-adyen-config-currency-input"
                            disabled={true}
                            name="currency_input"
                            id="currency_input"
                            placeholder={t("Select")}
                            value={currency !== "" ? currency : devise.label}
                            maxMenuHeight="90px"
                            className="mnt_drp_currency"
                        />
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel
                            htmlFor="example-input"
                            className="required__clz mt-3"
                        >
                            {t("Communication")}
                        </StyledLabel>
                        <StyledSelectInput
                            data-testid="monetics-adyen-config-communication-select"
                            name="communications_input"
                            id="communications_input"
                            options={communications}
                            onChange={(e: any) => {
                                setCommunication(e.label);
                                setAdyenConfig({
                                    ...adyenConfig,
                                    communication: e.label,
                                });
                                setInputCommunication(false);
                                setIsEdited(true);
                            }}
                            placeholder={t("Select")}
                            value={
                                communication !== ""
                                    ? {
                                          value: communication,
                                          label: communication,
                                      }
                                    : null
                            }
                            noOptionsMessage={() => t("No options")}
                            maxMenuHeight="90px"
                            className={classnames("mnt_drp_communication", {
                                input__clz: inputCommunication,
                                readOnly__clz: isConsult,
                            })}
                        />
                        {inputCommunication ? (
                            <FieldError style={{ color: "red" }}>
                                {t("Please select a communication")}
                            </FieldError>
                        ) : null}
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel
                            htmlFor="example-input"
                            className="required__clz mt-3"
                        >
                            {t("Webhook server URL")}
                        </StyledLabel>
                        <StyledTextInput
                            data-testid="monetics-adyen-config-webhook-input"
                            disabled={isAutoFill}
                            className={classnames("mnt_inp_webhookServerURL", {
                                input__clz: inputWebHook || isInvalidWebHook,
                                readOnly__clz: isConsult,
                            })}
                            autocomplete="off"
                            id="webhook_input"
                            name="webhook_input"
                            placeholder={t("Write")}
                            type="text"
                            onChange={(e: any) => {
                                if (
                                    !e.target.value.match(httpRegex) &&
                                    e.target.value !== ""
                                ) {
                                    setIsInvalidWebhook(true);
                                } else {
                                    setWebhook(e.target.value.trim());
                                    setAdyenConfig({
                                        ...adyenConfig,
                                        webhook: e.target.value.trim(),
                                    });
                                    setIsInvalidWebhook(false);
                                }

                                setInputWebhook(false);
                                setIsEdited(true);
                            }}
                            value={webhook}
                        />
                        {inputWebHook && (
                            <FieldError style={{ color: "red" }}>
                                {t("Please enter a webhook")}
                            </FieldError>
                        )}
                        {isInvalidWebHook && (
                            <FieldError style={{ color: "red" }}>
                                {t("Webhook is invalid")}
                            </FieldError>
                        )}
                    </AvGroup>
                    <AvGroup>
                        <div className="d-flex  align-items-center justify-content-between">
                            <div>{t("Print merchant ticket")}</div>
                            <div className="p-1 pr-4">
                                <ReactSwitch
                                    data-testid="monetics-adyen-config-merchant-ticket-switch"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    handleDiameter={26}
                                    offColor="#f7b4b8"
                                    offHandleColor="#E30613"
                                    checked={merchantTicket}
                                    onChange={(e: any) => {
                                        setMerchantTicket(!merchantTicket);
                                        setAdyenConfig({
                                            ...adyenConfig,
                                            merchantTicket: !merchantTicket,
                                        });

                                        setIsEdited(true);
                                    }}
                                    onColor="#c2eddd"
                                    onHandleColor="#34C38F"
                                    width={55}
                                    height={20}
                                    className={classnames(
                                        "mnt_icn_printTheMerchantReceipt",
                                        {
                                            readOnly__clz: isConsult,
                                        }
                                    )}
                                />
                            </div>
                        </div>
                    </AvGroup>
                    <AvGroup>
                        <div className="d-flex  align-items-center justify-content-between">
                            <div>{t("Print customer ticket")}</div>
                            <div className="p-1 pr-4">
                                <ReactSwitch
                                    data-testid="monetics-adyen-config-customer-ticket-switch"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    handleDiameter={26}
                                    offColor="#f7b4b8"
                                    offHandleColor="#E30613"
                                    checked={customerTicket}
                                    onChange={(e: any) => {
                                        setCustomerTicket(!customerTicket);
                                        setAdyenConfig({
                                            ...adyenConfig,
                                            customerTicket: !customerTicket,
                                        });
                                        setIsEdited(true);
                                    }}
                                    onColor="#c2eddd"
                                    onHandleColor="#34C38F"
                                    width={55}
                                    height={20}
                                    className={classnames(
                                        "mnt_icn_printTheCustomerTicket",
                                        {
                                            readOnly__clz: isConsult,
                                        }
                                    )}
                                />
                            </div>
                        </div>
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel
                            htmlFor="text"
                            className="mt-3 required__clz"
                        >
                            {t("API key")}
                        </StyledLabel>
                        <StyledTextInput
                            data-testid="monetics-adyen-config-api-key-input"
                            disabled={isAutoFill}
                            id="apiKey-input"
                            name="apiKey-input"
                            placeholder={t("Write")}
                            value={apiKey}
                            onChange={(e: any) => {
                                setApiKey(e.target.value.trim());
                                setAdyenConfig({
                                    ...adyenConfig,
                                    apiKey: e.target.value.trim(),
                                });
                                setInputApiKey(false);
                                setIsEdited(true);
                            }}
                            className={classnames("mnt_inp_apikey", {
                                input__clz: inputApiKey,
                                readOnly__clz: isConsult,
                            })}
                        />
                        {inputApiKey ? (
                            <FieldError style={{ color: "red" }}>
                                {t("Please enter an api key")}
                            </FieldError>
                        ) : null}
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel
                            htmlFor="text"
                            className="mt-3 required__clz"
                        >
                            {t("Username")}
                        </StyledLabel>
                        <StyledTextInput
                            data-testid="monetics-adyen-config-username-input"
                            disabled={isAutoFill}
                            id="user-name-input"
                            name="user-name-input"
                            placeholder={t("Write")}
                            value={userName}
                            onChange={(e: any) => {
                                setUserName(e.target.value.trim());
                                setAdyenConfig({
                                    ...adyenConfig,
                                    userName: e.target.value.trim(),
                                });
                                setInputUserName(false);
                                setIsEdited(true);
                            }}
                            className={classnames("mnt_inp_userName", {
                                input__clz: inputUserName,
                                readOnly__clz: isConsult,
                            })}
                        />
                        {inputUserName ? (
                            <FieldError style={{ color: "red" }}>
                                {t("Please enter a user name")}
                            </FieldError>
                        ) : null}
                    </AvGroup>{" "}
                    <AvGroup>
                        <StyledLabel
                            htmlFor="text"
                            className="mt-3 required__clz"
                        >
                            {t("Password")}
                        </StyledLabel>
                        <button
                            type="button"
                            className="new-password-toggle__clz mr-2 mnt_icn_passwordVisibility"
                            aria-label={
                                isNewPasswordDisplayed
                                    ? "Hide password"
                                    : "Show password"
                            }
                            onClick={() =>
                                setIsNewPasswordDisplayed((prev) => !prev)
                            }
                        >
                            {!isNewPasswordDisplayed ? (
                                <HidePasswordSvgIcon data-testid="monetics-adyen-config-password-toggle-hide" />
                            ) : (
                                <ShowPasswordSvgIcon data-testid="monetics-adyen-config-password-toggle-show" />
                            )}
                        </button>
                        <StyledTextInput
                            data-testid="monetics-adyen-config-password-input"
                            disabled={isAutoFill}
                            id="isNewPasswordDisplayed-input"
                            name="isNewPasswordDisplayed-input"
                            placeholder={t("Write")}
                            type={isNewPasswordDisplayed ? "text" : "password"}
                            value={userPassword}
                            onChange={(e: any) => {
                                setUserPassword(e.target.value.trim());
                                setAdyenConfig({
                                    ...adyenConfig,
                                    userPassword: e.target.value.trim(),
                                });
                                setInputUserPassword(false);
                                setIsEdited(true);
                            }}
                            className={classnames("mnt_inp_userPassword", {
                                input__clz: inputUserPassword,
                                readOnly__clz: isConsult,
                            })}
                        />
                        {inputUserPassword ? (
                            <FieldError style={{ color: "red" }}>
                                {t("Please enter a user password")}
                            </FieldError>
                        ) : null}
                    </AvGroup>
                </AvForm>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    data-testid="monetics-adyen-config-cancel-btn"
                    outline
                    variant="light"
                    onClick={cancelButtonOnClickEvent}
                    rounded
                    className="mnt_btn_cancelAlert"
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    data-testid="monetics-adyen-config-validate-btn"
                    rounded
                    className={classnames("mr-2 cmn_btn_boutonValiderAlert", {
                        readOnly__clz: isConsult,
                    })}
                    variant="primary"
                    onClick={handleValidate}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
